<template>
  <div class="big">
    <div class="container">
      <div class="searchbox wrap">
        <div class="item">
          <span>搜索词</span>
          <el-input
            placeholder="请输入"
            v-model="search_name"
            style="width: 200px; margin: 0 12px 0 8px"
            clearable=""
            @change="search"
          ></el-input>
        </div>

        <div class="item">
          <span>搜索时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 230px; margin: 0 12px 0 8px"
            @change="search"
          >
          </el-date-picker>
          <el-button
            type="info"
            @click="search"
            style="background-color: #eceff2; color: #747981"
            >查询</el-button
          >
        </div>
      </div>

      <div style="border: solid 1px #c9cbd6; margin-top: 12px">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          @sort-change="changeOrder"
        >
          <el-table-column prop="search_name" label="搜索词"> </el-table-column>
          <el-table-column
            prop="create_time_start"
            label="首次搜索时间"
          ></el-table-column>
          <el-table-column
            prop="search_count"
            label="搜索次数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="user_count"
            label="搜索用户数"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="create_time_end"
            label="近期搜索时间"
          ></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1503') : false
                "
                @click="toDetail(scope.row.search_name)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin: 30px 0 20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      search_name: "",
      date: [],
      sort_col: "",
      sort_order: "",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        search_name: this.search_name,
        create_time_end: this.doctor_phone,
        search_from: 1,
        sort_col: this.sort_col,
        sort_order: this.sort_order,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Searchlog/getMedicalStatListPaging", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time_start = dayjs
                .unix(item.create_time_start)
                .format("YYYY-MM-DD HH:mm");
              item.create_time_end = dayjs
                .unix(item.create_time_end)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });

            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    changeOrder(value) {
      this.sort_col = value.prop;
      //升序
      if (value.order == "ascending") {
        this.sort_order = "asc";
      }
      //降序
      if (value.order == "descending") {
        this.sort_order = "desc";
      }
      if (!value.order) {
        this.sort_col = "";
        this.sort_order = "";
      }
      this.getList();
    },
    //详情
    toDetail(search_name) {
      console.log(search_name);
      this.$router.push({
        path: "diagnosis",
        query: {
          search_name,
        },
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  .item {
    margin-bottom: 20px;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>
